exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-rb-questions {\r\n    margin-top: 10px;\r\n}\r\n\r\n.label-radio {\r\n    margin-left: 10px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/question/question.component.css
// module id = ../../../../../src/app/components/question/question.component.css
// module chunks = main